export default __webpack_public_path__ + "static/media/menu-help-icon.cc227321.svg";